import { useEffect, useState } from "react";
import { MapPin } from "lucide-react";

const PICKER_URL = "https://embed.sendcloud.sc/spp/1.0.0/api.min.js";
let pickerPromise = null;
function loadPicker() {
  if (!pickerPromise) pickerPromise = new Promise((resolve, reject) => {
    if (window.sendcloud?.servicePoints?.open) { resolve(); return; }
    const script = document.createElement("script");
    script.src = PICKER_URL;
    script.async = true;
    script.onload = () => window.sendcloud?.servicePoints?.open ? resolve() : reject(new Error("Sendcloud picker unavailable"));
    script.onerror = reject;
    document.body.appendChild(script);
  }).catch((error) => { pickerPromise = null; throw error; });
  return pickerPromise;
}

export const RelayPicker = ({ apiKey, postalCode, carrier, value, onChange }) => {
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState("");
  useEffect(() => { if (apiKey) loadPicker().catch(() => {}); }, [apiKey]);

  const open = async () => {
    if (!apiKey) { setStatus("error"); setError("Sélection des points relais indisponible pour le moment."); return; }
    setStatus("loading"); setError("");
    try {
      await loadPicker();
      window.sendcloud.servicePoints.open({
        apiKey, country: "fr", language: "fr-fr", postalCode: postalCode || "",
        carriers: ({ mondialrelay: "mondial_relay", chronopost: "chronopost", colissimo: "colissimo" })[String(carrier || "").toLowerCase().replace(/[^a-z]/g, "")] || "mondial_relay,chronopost,colissimo",
      }, (point) => {
        const addr = [point.street || point.address, point.house_number].filter(Boolean).join(" ").trim();
        const selected = {
          id: String(point.id || ""),
          name: String(point.name || "").slice(0, 120),
          address: addr.slice(0, 200),
          postal_code: String(point.postal_code || point.postalCode || "").slice(0, 12),
          city: String(point.city || "").slice(0, 80),
          country: "FR",
          carrier: String(point.carrier || "Point relais").slice(0, 60),
        };
        if (!selected.id || !selected.name || !selected.address || !selected.postal_code || !selected.city) {
          setError("Adresse du point relais incomplète. Choisissez un autre point."); setStatus("error"); return;
        }
        onChange(selected); setStatus("ready");
      }, () => { setError("Impossible d'ouvrir les points relais. Réessayez."); setStatus("error"); });
      setStatus("ready");
    } catch {
      setError("La carte des points relais est indisponible. Réessayez plus tard."); setStatus("error");
    }
  };
  return (
    <div className="mt-6" data-testid="relay-picker">
      <p className="text-[10px] tracking-[0.2em] uppercase text-[#F8F6F1]/50 mb-2">Choisissez votre point relais</p>
      <button type="button" onClick={open} disabled={status === "loading"} className="btn-outline-gold !py-3" data-testid="relay-picker-open">{status === "loading" ? "Ouverture…" : value ? "Changer de point relais" : "Choisir un point relais sur la carte"}</button>
      {error && <p className="text-sm text-red-300 mt-3" role="alert">{error}</p>}
      {value && <div className="mt-4 border border-[#C9A45C] bg-[#C9A45C]/5 p-4 flex gap-3" data-testid="relay-selected">
        <MapPin className="h-5 w-5 text-[#C9A45C] shrink-0 mt-0.5" />
        <div className="text-sm">
          <p className="font-medium" data-testid="relay-selected-name">{value.name}</p>
          <p className="text-[#F8F6F1]/65">{value.address}, {value.postal_code} {value.city}</p>
          <p className="text-xs text-[#F8F6F1]/45 mt-1">{value.carrier} · n° {value.id}</p>
        </div>
      </div>}
    </div>
  );
};

